import React from 'react';
import styled from 'styled-components';
import { Button, KeywordSearch } from 'components';
import { FiltersIcon } from 'assets/svgs';

function MobileSearchAndFilters({ searchQuery, handleSearchInput, setShowProductFiltersDialog }) {
  return (
    <Container>
      <h3>Search by keywords:</h3>
      <KeywordSearch searchQuery={searchQuery} handleSearchInput={handleSearchInput} />
      <FiltersButton onClick={() => setShowProductFiltersDialog(true)}>
        Use Filters&nbsp;
        <FiltersIcon />
      </FiltersButton>
    </Container>
  );
}

const Container = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  grid-column: 1/-1;
  margin: 0 auto;

  > h3 {
    margin-bottom: 1.25rem;
  }

  /* Keyword Search */
  > div:first-of-type {
    position: relative;
    width: 300px !important;

    input {
      padding-left: unset;
      text-align: center;

      &::placeholder {
        text-align: center;
      }

      &:focus + svg {
        display: none;
      }
    }

    svg {
      left: calc(50% - 10.6px);
      pointer-events: none;
      position: absolute;
    }
  }
`;

const FiltersButton = styled(Button)`
  flex-wrap: nowrap;
  gap: 10px;
  height: 48px;
  margin: 29px auto 30px !important;
  padding: 10px 20px !important;
  white-space: nowrap;
  width: 164px;

  svg {
    width: 19px;
  }
`;

export default MobileSearchAndFilters;
